<template>
    <div class="flex flex-col py-7 px-5 bg-white border border-valence-grey-300 rounded-lgr w-full h-full" :title="tooltip">
        <i v-if="icon" class="mb-5 bi text-base" :class="icon" aria-hidden="true"></i>
        <div class="body-small-semibold text-neutral-800 mb-1">{{ label }}</div>
        <SkeletonLoader v-if="isLoading" class="h-9 w-full rounded-lgr" />
        <div v-else class="title-section text-neutral-800">{{ formattedValue }}</div>
    </div>
</template>

<script setup lang="ts">
import SkeletonLoader from "~vue/components/SkeletonLoader.vue";
import { computed } from "vue";

const {
    label = "",
    value = "",
    isLoading = false,
} = defineProps<{
    icon?: string;
    label?: string;
    value?: string | number;
    isLoading?: boolean;
    tooltip?: string;
}>();

const formattedValue = computed(() => {
    if (typeof value === "number") {
        return value.toLocaleString();
    }

    const numberValue = Number.parseFloat(value);
    if (Number.isNaN(numberValue)) {
        return value || "--";
    }

    return numberValue.toLocaleString();
});
</script>
